// Centralized shared constants for stats-ksat frontend modules.
// GROUP_COLORS is the single source of truth for transaction-group colors,
// consumed by home.ts (stacked column chart) and transactions.ts (donut + monthly chart).

export const GROUP_COLORS: Record<string, string> = {
    'Food & Beverage':      '#FF6B6B',
    'Grocery':              '#4ECDC4',
    'Amazon':               '#FF9F43',
    'Clothing':             '#A29BFE',
    'Fuel':                 '#FD79A8',
    'Entertainment':        '#6C5CE7',
    'Online Entertainment': '#74B9FF',
    'Alcohol':              '#3BABD3',
    'Gym':                  '#00B894',
    'Bank':                 '#636E72',
    'Work':                 '#0984E3',
    'Server':               '#00CEC9',
    'Games':                '#E17055',
    'Miscellaneous':        '#B2BEC3',
    'Personal Care':        '#FDCB6E',
    'Shipping':             '#55EFC4',
    'Rock Climbing':        '#D63031',
    'Donation':             '#27AE60',
    'Travel':               '#8E44AD',
    'Merchandise':          '#F39C12',
    'Accessories':          '#1ABC9C',
    'Fun':                  '#E74C3C',
    'Dealership':           '#95A5A6',
    'Computers':            '#2980B9',
    'Uncategorized':        '#DFE6E9',
};

/**
 * Resolves a group name to a stable color. Returns curated color from GROUP_COLORS
 * if present, else a deterministic HSL derived from a simple string hash so each
 * unknown group keeps the same color across page loads (no console warning).
 */
export function groupColor(name: string): string {
    if (GROUP_COLORS[name]) return GROUP_COLORS[name];
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
        hash = ((hash << 5) - hash) + name.charCodeAt(i);
        hash |= 0;  // force 32-bit int
    }
    const hue = Math.abs(hash) % 360;
    return `hsl(${hue}, 65%, 55%)`;
}
